module.exports = __webpack_public_path__ + "img/ROSE.8b0b550b.png";